module.exports = __webpack_public_path__ + "static/media/chevron-right.b4b31621.svg";